import React, {useState, useEffect, useCallback} from 'react';
import {useNavigate} from 'react-router-dom';
import Header from './components/Header';
import Get from './components/Get';
import BottomTabs from './BottomTabs';
import {bottomNavigationActionClasses} from '@mui/material';

const GameCard = React.memo(({data, onAction}) => {
  return (
    <div style={styles.card}>
      <div style={styles.cardHeader}>
        <div style={styles.cardHeaderText}>
          <h3 style={styles.title}>{data.name?.name}</h3>
          <p style={styles.time}>
            Timing: {data.start_time} - {data.end_time}
          </p>
        </div>
        {data.status === '1' ? (
          <button
            style={{...styles.actionButton, ...styles.playButton}}
            onClick={() => onAction(true, data)}>
            ▶ Play Now
          </button>
        ) : (
          <button
            style={{...styles.actionButton, ...styles.timeoutButton}}
            onClick={() => onAction(false, data)}>
            ⏳ Time Out
          </button>
        )}
      </div>
    </div>
  );
});

const Gamelist = () => {
  const navigate = useNavigate();
  const [gamesData, setGamesData] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchGames = useCallback(async () => {
    setLoading(true);
    try {
      const res = await Get.gamelist();
      if (res && res.data) {
        setGamesData(res.data);
      } else {
        setGamesData([]);
      }
    } catch (error) {
      console.error('Failed to fetch games:', error);
      alert('Could not load the game list. Please try again later.');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchGames();
  }, [fetchGames]);

  const handleAction = (status, data) => {
    if (status) {
      navigate('/playoption', {state: {data}});
    } else {
      alert('This game time has expired. Please try another match.');
    }
  };

  return (
    <>
      <div style={styles.container}>
        <Header title="Game List" />

        {loading ? (
          <div style={styles.emptyContainer}>
            <p style={styles.emptyText}>Loading Games...</p>
          </div>
        ) : gamesData.length > 0 ? (
          <div style={styles.scrollContent}>
            {gamesData.map((data, index) => (
              <GameCard
                key={data.id || index}
                data={data}
                onAction={handleAction}
              />
            ))}
          </div>
        ) : (
          <div style={styles.emptyContainer}>
            <p style={styles.emptyText}>No Active Games Found</p>
            <p style={styles.emptySubText}>
              Please check back later for new matches.
            </p>
          </div>
        )}
      </div>
      <BottomTabs />
    </>
  );
};

export default Gamelist;

const styles = {
  container: {
    backgroundColor: '#fff',
    minHeight: '100vh',
    fontFamily: 'Arial, sans-serif',
    marginBottom: 40,
  },
  scrollContent: {
    padding: '15px',
    marginTop: '10px',
  },
  card: {
    backgroundColor: '#34699A',
    borderRadius: '12px',
    padding: '18px',
    marginBottom: '12px',
    boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
    color: '#E2E8F0',
  },
  cardHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  cardHeaderText: {
    flex: 1,
  },
  title: {
    fontWeight: 'bold',
    fontSize: '18px',
    marginBottom: '4px',
  },
  time: {
    fontSize: '12px',
    color: '#A0AEC0',
    fontWeight: '600',
  },
  actionButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '8px 14px',
    borderRadius: '8px',
    fontWeight: 'bold',
    fontSize: '12px',
    border: 'none',
    cursor: 'pointer',
    color: '#fff',
  },
  playButton: {
    backgroundColor: '#0AB4A7',
  },
  timeoutButton: {
    backgroundColor: '#4A5568',
  },
  emptyContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: '50px',
  },
  emptyText: {
    fontSize: '18px',
    fontWeight: 'bold',
    color: '#333',
    marginTop: '10px',
  },
  emptySubText: {
    fontSize: '14px',
    color: '#666',
    marginTop: '5px',
  },
};
